export enum VoterType {
    PERCENTAGE = 'Percentage Change',
    RATIO = 'Registered Voters'
}